import api from './axiosConfig';

export const productApi = {
  getProducts: () => api.get('/v1/products'),
  addProduct: (data) => api.post('/v1/products', data),
  updateProduct: (id, data) => api.put(`/v1/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/v1/products/${id}`)
};
